import { useLocalization } from 'redux/localization/utils/hooks';

const FormError = (props) => {
  const { touch, error, id, label } = props;
  const { t } = useLocalization();

  const errorMessage = getErrorMessage(error, label, t);

  if (touch && error) {
    return (
      <p id={id} className="c7-form__error" aria-live="polite">
        {errorMessage}
      </p>
    );
  }
  return null;
};

const getErrorMessage = (error, label, t) => {
  if (!error) {
    return null;
  }

  if (error.toLowerCase() === 'required' && typeof label === 'string') {
    return t('general.errorMessages.requiredField', { label });
  }

  return error;
};

export default FormError;
